import React from "react";
import { Box } from "@mui/material";

import {
  StyledChannelPerformanceCard,
  StyledInfoBox,
  StyledInfoBoxTitle,
  StyledInfoBoxNumber,
} from "./ChannelPerformance.styles";
import IconTooltip from "@metacrm/metacrm-material-ui/dist/IconTooltip";
import { useIntl } from "react-intl";
import {
  formatNumberWithComma,
  formatPercentage,
  transformRate,
} from "features/helpers/utils";
import { FormattedMessage } from "react-intl";
import { get, isNumber, isFinite } from "lodash-es";

const ChannelPerformance = ({ channelPerformanceData }) => {
  const { formatMessage } = useIntl();
  const {
    title,
    icon,
    titleTooltip,
    sent,
    opened,
    conversionRate,
    subscribedUsers,
  } = channelPerformanceData;

  return (
    <StyledChannelPerformanceCard>
      <Box className="betweenRow" mb={1}>
        <Box className="startRow">
          {icon}
          <Box mr={0.5}>{title}</Box>
          {titleTooltip && <IconTooltip content={titleTooltip} />}
        </Box>
        <Box className="endRow">
          {subscribedUsers?.title && (
            <Box mr="8px" color="#A5A5A5" fontSize="12px" fontWeight={500}>
              {subscribedUsers?.title}
            </Box>
          )}
          {subscribedUsers?.value && (
            <Box color="#777" fontSize="12px" fontWeight={500} mr="4px">
              {subscribedUsers?.value}
            </Box>
          )}
          {subscribedUsers?.tooltip && (
            <IconTooltip content={subscribedUsers?.tooltip} />
          )}
        </Box>
      </Box>

      <Box display={"flex"}>
        <StyledInfoBox flex={1}>
          <StyledInfoBoxTitle>
            {formatMessage({ id: "global.metrics.sent" })}
          </StyledInfoBoxTitle>
          <StyledInfoBoxNumber>
            {isNumber(sent.number) ? formatNumberWithComma(sent.number) : "N/A"}
          </StyledInfoBoxNumber>
        </StyledInfoBox>

        <StyledInfoBox flex={1}>
          <StyledInfoBoxTitle>
            {formatMessage({ id: "global.metrics.open" })}
          </StyledInfoBoxTitle>
          <StyledInfoBoxNumber>
            {isNumber(opened.number)
              ? formatNumberWithComma(opened.number)
              : "N/A"}
          </StyledInfoBoxNumber>
        </StyledInfoBox>

        <StyledInfoBox flex={1}>
          <StyledInfoBoxTitle>
            {formatMessage({ id: "global.metrics.conversionRate" })}
            <IconTooltip
              content={formatMessage({ id: "notification.report.cvrTooltip" })}
            />
          </StyledInfoBoxTitle>
          <StyledInfoBoxNumber>
            {isNumber(conversionRate.number) && isFinite(conversionRate.number)
              ? formatPercentage(conversionRate.number)
              : "N/A"}
          </StyledInfoBoxNumber>
        </StyledInfoBox>
      </Box>
    </StyledChannelPerformanceCard>
  );
};

export default ChannelPerformance;
